// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-012175dc] .basic__label-row-item-content{-webkit-box-flex:0!important;-ms-flex:none!important;flex:none!important;width:calc(100% - 75px)!important;word-break:break-all}", ""]);
// Exports
module.exports = exports;
